import {
  ListBranchRequest,
  useListBranchQuery,
} from "@/services/backend/company/api/branch";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import t from "@/lang/lang";
import { CompanyName } from "@/services/backend/company/components/company-name";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { DeleteBranchDialog } from "@/services/backend/company/components/delete-branch-dialog";
import { Button } from "@/shared/components/ui/button";
import { ReactNode } from "react";
import { Search } from "lucide-react";

interface Props {
  renderRowLink: (branchId: string, children: ReactNode) => ReactNode;
}

export function BranchesTable({ renderRowLink }: Props) {
  const {
    data: list,
    isLoading,
    error,
  } = useListBranchQuery({} as ListBranchRequest);

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t("Niederlassung")}</TableHead>
          <TableHead>{t("Unternehmen")}</TableHead>
          <TableHead>{t("Aktionen")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {list?.branches.map((branch) => (
          <TableRow key={branch.id}>
            <TableCell>
              {renderRowLink(
                branch.id,
                <Button size="sm" variant="link" className="text-foreground">
                  {branch.name}
                </Button>,
              )}
            </TableCell>
            <TableCell>
              <CompanyName companyId={branch.companyId} short />
            </TableCell>
            <TableCell className="space-x-2 text-right">
              {renderRowLink(
                branch.id,
                <Button size="sm" variant="outline">
                  <Search className="size-4" />
                </Button>,
              )}
              <DeleteBranchDialog branch={branch} />
            </TableCell>
          </TableRow>
        ))}
        {isLoading && (
          <TableRow>
            <TableCell colSpan={3} className="animate-pulse">
              {t("Loading...")}
            </TableCell>
          </TableRow>
        )}
        {error && (
          <TableRow>
            <TableCell colSpan={3}>
              <RTKQueryErrorAlert error={error} />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
